import { Fragment } from "react";
import { Link } from "react-router-dom";
const toTop = () => {
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
};

const franchisingData = {
    en: {
        title: "Captain Candy Franchising",
        history: [
            {
                question: "Captain Candy concept caught your eye?",
                answer: "Captain Candy is a successful and proven concept operating a network of candy shops. Our shops are so unique that in many cases they have been the subject of illegal copying. However, there is only one original Captain Candy. In our stores, we do not only focus on a wide selection of the most delicious candies, but the overall customer experience is just as important to us.",
            },
            {
                question: "Keen to spread the joy of returning to being a kid to others around you?",
                answer: <Fragment>With a Captain Candy franchise, you can offer your customers the joy of discovery and the excitement of returning to their childhood. <br />
                For more information, please fill out the questionnaire below.</Fragment>
            },
        ],
        list: [
            {
                headingtitle: "Why work with us as a franchising partner?",
                headingLi: [
                    'Our concept boasts its own unique style',
                    "We offer quality of an international calibre",
                    "We’re constantly developing and improving",
                    "We’re a tried and tested European brand",
                ],
            },
            {
                headingtitle: "What we offer franchising partners?",
                headingLi: [
                    "The security of working for an international brand",
                    "Tried and tested sales know-how, which is constantly being innovated",
                    "Well-thought out, tried and tested and ready-made solutions",
                    "Help not only before opening your store and in the early stages, but also any time further down the line",
                    "The opportunity for personal development and self-realisation in getting your business off the ground",
                    "The chance to contribute to the development and growth of the brand",
                    "Stocking up with products and the necessary equipment to operate a franchise",
                    "System of regular checks and consultations",
                    "Long-term income and appreciation of your investment",
                    "Mutual agreement on a specific form of cooperation",
                ]
            }
        ],
        listParagraphsTitle: "How to get a Captain Candy franchise",
        listParagraphs:  [
            "We see franchising as a longstanding and mutually beneficial relationship, a bit like accepting another person into our business family. We therefore take great care to ensure our selection process is fair, thorough and prudent.",
            " For this reason anyone interested in applying is asked to complete a QUESTIONNAIRE to share preliminary (and non-binding) information with us, which allows us to ascertain whether our future collaboration is built on sufficiently solid foundations and has real prospects for success. We’ll get in touch after reading through your responses.",
            <Fragment><i> By sending your responses, you are automatically entered onto our database of people interested in working with us. We treat any information contained in the questionnaire in accordance with the General Data Protection Regulation (GDPR) and use it exclusively for the purpose of potential collaboration with you.</i></Fragment>,
        ],
        questionTitle: "QUESTIONNAIRE",
        inputs: [
            {
                id: "contactform_fullName",
                name: "contactform_fullName",
                label: "Name and surname*",
            },
            {
                id: "contactform_email",
                name: "contactform_email",
                label: "E-mail*",
            },
            {
                id: "contactform_phone",
                name: "contactform_phone",
                label: "Telephone number*",
                class: "inputphone",
                style: { display: "inline-block" },
            },
            {
                id: "contactform_text_1",
                name: "contactform_text_1",
                label: "Why do you want to work with Captain Candy?",
                textarea: true,
            },
            {
                id: "contactform_text_2",
                name: "contactform_text_2",
                label: "How did you find out about Captain Candy?",
                textarea: true,
            },
            {
                id: "contactform_text_3",
                name: "contactform_text_3",
                label: "What is your current professional experience?*",
                textarea: true,
            },
            {
                id: "file_upload",
                name: "file_upload",
                label: "Please attach a detailed CV*",
                button: "Browse"
            },
            {
                id: "contactform_text_4",
                name: "contactform_text_4",
                label: "Do you have any experience running a small business? If o what?*",
                textarea: true,
            },
            {
                id: "contactform_text_5",
                name: "contactform_text_5",
                label: "Do you work for any other brands?*",
                textarea: true,
            },
            {
                id: "contactform_text_6",
                name: "contactform_text_6",
                label: "Do you have any other commitments or things that would restrict you from this work? Have you signed a competition clause preventing you from working with a particular brand or concept?*",
                textarea: true,
            },
            {
                id: "contactform_text_7",
                name: "contactform_text_7",
                label: "Do you or have you (or anyone close to you) previously run a franchise?",
                textarea: true,
            },
            {
                id: "contactform_text_8",
                name: "contactform_text_8",
                label: "If you’ve never run your own business before, what is your motivation for starting one now?",
                textarea: true,
            },
            {
                id: "contactform_text_9",
                name: "contactform_text_9",
                label: "Do you have a clean criminal record and are you prepared to supply proof of this?*",
                textarea: true,
            },
            {
                id: "contactform_text_10",
                name: "contactform_text_10",
                label: "To what degree can you take part in the day to day running of the store?*",
                textarea: true,
            },
            {
                id: "contactform_text_11",
                name: "contactform_text_11",
                label: "What makes you think that Captain Candy will be a success in your city, country or region?",
                textarea: true,
            },
            {
                id: "contactform_text_12",
                name: "contactform_text_12",
                label: "Where do you want to open your premises? What town, big city, region or country interest you in terms of running Captain Candy franchising stores?*",
                textarea: true,
            },
            {
                id: "contactform_text_13",
                name: "contactform_text_13",
                label: "Do you have your own/rented sales spaces to run your Captain Candy store? How big is it, what are the floor plans and where is it? How long will you have it for?",
                textarea: true,
            },
            {
                id: "contactform_text_14",
                name: "contactform_text_14",
                label: "What level of funds are you prepared to invest in the Captain Candy project? How do you plan to finance construction, furnishings and running costs during the start-up phase? How much can you source from your own funds?*",
                textarea: true,
            },
        ],
        link: <Fragment>“I consent to the  <Link  onClick={() => toTop()} to="/personal-data-processing" className="link">processing of my personal data</Link> and the responses given in the questionnaire.</Fragment>,
        button: "Send"
    },
    ka: {
        title: "Captain Candy ფრანჩაიზინგი",
        history: [
            {
                question: "დაგაინტერესათ Captain Candy-ის კონცეფციამ?",
                answer: "Captain Candy არის წარმატებული და გამოცდილი კონცეფცია ტკბილეულის მაღაზიების კარგი ქსელით. ჩვენი მაღაზიები ისეთი უნიკალურია, რომ ბევრ შემთხვევაში უკანონო კოპირების ობიექტი გახდა. როგორც არ უნდა იყოს, არსებობს მხოლოდ ერთი ორიგინალი Captain Candy. ჩვენს მაღაზიებში ვთავაზობთ არა მხოლოდ ყველაზე გემრიელი ტკბილეულის ფართო არჩევანს, არამედ მთლიანი მომხმარებლის გამოცდილებაც მნიშვნელოვანია ჩვენთვის.",
            },
            {
                question: "გსურთ თქვენს გარშემო ხალხს გაუზიაროთ აღმოჩენის სიხარული და ბავშვობაში დაბრუნების აღფრთოვანება?",
                answer: <Fragment>Captain Candy-ის ფრანჩაიზის მაღაზიით თქვენს მომხმარებლებს დაუბრუნებთ აღმოჩენის სიხარულსა და ბავშვობის ხიბლს.
                        <br/>
                        თუ დამატებითი ინფორმაცია გსურთ, გთხოვთ, შეავსოთ ქვემოთ მოცემული კითხვარი.
                    </Fragment>,
            },
        ],
        list: [
            {
                headingtitle: "რატომ უნდა ითანამშრომლოთ ჩვენთან, როგორც ფრანჩაიზის პარტნიორი?",
                headingLi: [
                    "ჩვენს კონცეფციას აქვს თავისი უნიკალური სტილი",
                    "ვთავაზობთ საერთაშორისო დონის ხარისხს",
                    "მუდმივად ვავითარებთ და ვაუმჯობესებთ კონცეფციას",
                    "ჩვენ გამოცდილი ევროპული ბრენდი ვართ",
                ],
            },
            {
                headingtitle: "რას ვთავაზობთ ჩვენს ფრანჩაიზის პარტნიორებს?",
                headingLi: [
                    "წარმატებული ბიზნესის უსაფრთხოება საერთაშორისო ბრენდის ქვეშ",
                    "გამოცდილი გაყიდვების ნოუ-ჰაუ, რომელსაც მუდმივად ვავითარებთ",
                    "მოფიქრებული, გამოცდილი, დადასტურებული და მზა გადაწყვეტილებები",
                    "გეხმარებით არა მხოლოდ გახსნამდე და დასაწყისში, არამედ ნებისმიერ დროს მის შემდეგაც",
                    "პიროვნული განვითარებისა და თვითრეალიზაციის შესაძლებლობა თქვენი მაღაზიის გახსნისას",
                    "ბრენდის განვითარებასა და ზრდაში მონაწილეობის შესაძლებლობა",
                    "ფრანჩაიზის ფუნქციონირებისთვის საჭირო პროდუქციისა და აღჭურვილობის მიწოდება",
                    "შემოწმებებისა და კონსულტაციების სისტემა",
                    "გრძელვადიანი შემოსავალი და თქვენი ინვესტიციის ანაზღაურება",
                    "ურთიერთშეთანხმება თანამშრომლობის კონკრეტული ფორმის შესახებ",
                ]
            }
        ],
        listParagraphsTitle: "როგორ დავაარსო ფრანჩაიზის ბიზნესი Captain Candy-სთან ერთად?",
        listParagraphs:  [
            "ფრანჩაიზინგი ჩვენთვის გრძელვადიანი და ორმხრივად სასარგებლო ურთიერთობაა, ისევე როგორც ჩვენს ბიზნეს-ოჯახში კიდევ ერთი წევრის მიღება. ამიტომ შერჩევას სამართლიანად, გულდასმით და წინდახედულად ვუდგებით.",
            "ყველა დაინტერესებული პირისთვის, ვინც ჩვენ მოგვმართავს, ჯერ ვიწყებთ წინასწარ (და არასავალდებულო) ინფორმაციის გაცვლას კითხვარის მეშვეობით, რათა დავინახოთ, აქვს თუ არა ჩვენს შესაძლო თანამშრომლობას საკმარისი საფუძველი და რეალისტური პერსპექტივა. დავამუშავებთ თქვენს პასუხებს და შემდეგ დაგიკავშირდებით.",
            <Fragment><i>პასუხების გამოგზავნით ავტომატურად შეგიყვანთ თანამშრომლობით დაინტერესებულ პირთა მონაცემთა ბაზაში. კითხვარში მოცემულ მონაცემებს ვამუშავებთ მონაცემთა დაცვის კანონის (GDPR) შესაბამისად და ვიყენებთ მხოლოდ თანამშრომლობის მიზნით.</i></Fragment>,
        ],
        questionTitle: "კითხვარი",
        inputs: [
            {
                id: "contactform_fullName",
                name: "contactform_fullName",
                label: "სახელი და გვარი*",
            },
            {
                id: "contactform_email",
                name: "contactform_email",
                label: "ელფოსტა*",
            },
            {
                id: "contactform_phone",
                name: "contactform_phone",
                label: "ტელეფონი*",
                class: "inputphone",
                style: { display: "inline-block" },
            },
            {
                id: "contactform_text_1",
                name: "contactform_text_1",
                label: "რატომ გსურთ Captain Candy-სთან თანამშრომლობა?",
                textarea: true,
            },
            {
                id: "contactform_text_2",
                name: "contactform_text_2",
                label: "საიდან შეიტყვეთ Captain Candy-ის შესახებ?",
                textarea: true,
            },
            {
                id: "contactform_text_3",
                name: "contactform_text_3",
                label: "როგორია თქვენი მიმდინარე პროფესიული გამოცდილება?*",
                textarea: true,
            },
            {
                id: "file_upload",
                name: "file_upload",
                label: "გთხოვთ, დაურთოთ დეტალური რეზიუმე – CV*",
                button: "ფაილის არჩევა"
            },
            {
                id: "contactform_text_4",
                name: "contactform_text_4",
                label: "გაქვთ მცირე ბიზნესის მართვის გამოცდილება? თუ კი, რა?",
                textarea: true,
            },
            {
                id: "contactform_text_5",
                name: "contactform_text_5",
                label: "მუშაობთ სხვა ბრენდებისთვის?*",
                textarea: true,
            },
            {
                id: "contactform_text_6",
                name: "contactform_text_6",
                label: "გაქვთ ვალდებულებები, შეზღუდვები ან კონკურენციის აკრძალვა რომელიმე ბრენდის ან კონცეფციის მიმართ?*",
                textarea: true,
            },
            {
                id: "contactform_text_7",
                name: "contactform_text_7",
                label: "მართავთ ან მართავდით თქვენ ან თქვენთან ახლობელი ადამიანი ფრანჩაიზის ბიზნესს?",
                textarea: true,
            },
            {
                id: "contactform_text_8",
                name: "contactform_text_8",
                label: "თუ აქამდე საკუთარი ბიზნესი არ გქონიათ, რა გიბიძგებთ ახლა მის დაწყებას?",
                textarea: true,
            },
            {
                id: "contactform_text_9",
                name: "contactform_text_9",
                label: "გაქვთ უნაკლო ნასამართლობის ცნობა და მზად ხართ ეს დაადასტუროთ?*",
                textarea: true,
            },
            {
                id: "contactform_text_10",
                name: "contactform_text_10",
                label: "რამდენად შეგიძლიათ აქტიურად ჩაერთოთ მაღაზიის ყოველდღიურ მართვაში?*",
                textarea: true,
            },
            {
                id: "contactform_text_11",
                name: "contactform_text_11",
                label: "რატომ ფიქრობთ, რომ Captain Candy წარმატებული იქნება თქვენს ქალაქში, ქვეყანაში ან რეგიონში?",
                textarea: true,
            },
            {
                id: "contactform_text_12",
                name: "contactform_text_12",
                label: "სად გსურთ თქვენი მაღაზიის გახსნა? რომელი ქალაქი, დიდი ქალაქი, რეგიონი ან ქვეყანა გაინტერესებთ Captain Candy-ის ფრანჩაიზის მაღაზიების მართვის თვალსაზრისით?*",
                textarea: true,
            },
            {
                id: "contactform_text_13",
                name: "contactform_text_13",
                label: "გაქვთ საკუთარი ან ნაქირავები საგაყიდვო ფართი Captain Candy-ის მაღაზიის გასახსნელად? რა ზომისაა, როგორია მისი გეგმა და სად მდებარეობს? რამდენ ხანს გექნებათ?",
                textarea: true,
            },
            {
                id: "contactform_text_14",
                name: "contactform_text_14",
                label: "რა ოდენობის ფინანსური სახსრების ინვესტირებას აპირებთ Captain Candy-ის პროექტში? როგორ გეგმავთ მშენებლობის, აღჭურვილობისა და საქმიანობის დაფინანსებას სტარტ-აპის ფაზაში? რა ნაწილს უზრუნველყოფთ საკუთარი სახსრებიდან?*",
                textarea: true,
            },
        ],
        link: <Fragment>„ვეთანხმები <Link  onClick={() => toTop()} to="/personal-data-processing" className="link">პერსონალური მონაცემების დამუშავების</Link> პირობებსა და კითხვარში მოცემულ პასუხებს.“</Fragment>,
        button: "გაგზავნა"
    },
};

export {
    franchisingData,
}